module.exports = __webpack_public_path__ + "img/icon5@3x.b773f05c.png";